import sysMenu from '../../components/sys-menu/index.vue';
import sysHeader from '../../components/sys-header/index.vue';
import sysPageTab from '../../components/sys-page-tab/index.vue';
export default {
    data() {
        return {
            collapsed: false
        }
    },
    computed: {
        keepAlive() {
            console.log(this.$store.state.keepAlive.join(","))
            return this.$store.state.keepAlive;
        }
    },
    components: {
        sysMenu,
        sysHeader,
        sysPageTab
    },
    mounted: function() {
        // 收缩、展开菜单事件接收
        this.$event.$on('changeCollapse', (collapsed) => {
            this.collapsed = collapsed;
        });
        if (this.$route.fullPath != '/console')
            this.$router.push("/console");
    },

    methods: {

    }
}